module.exports = __webpack_public_path__ + "static/media/icon_whatsapp.ac97c489.svg";